<template>
  <div style="min-height: 300px;"
       class="m-2">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>

    <b-container fluid
                 v-show="!loading">
      <b-row>
        <b-col>
          <apex-chart ref="chart"
                      height="250"
                      :options="chartOptions"
                      :series="series"/>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <esg-base-table :items="tableItems"
                          :fields="tableFields"
                          size="sm">
          </esg-base-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import EsgBaseTable from "@/components/esg/base/EsgBaseTable.vue";

export default {
  components: { EsgBaseTable },
  props: {
    productFamily: {
      type: Object,
      default: () => ({
        code: null,
        name: null
      })
    },
    category: {
      type: Object,
      required: true
    }
  },
  watch: {
    productFamily: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    category: {
      immediate: true,
      handler() {
        this.fetchData()
      }
    }
  },
  data() {
    return {
      loading: false,
      tableItems: [],
      tableFields: [
        {
          name: "product_name",
          label: "제품",
          list: true,
        },
        {
          name: "values",
          label: "배출량 (tCO2e)",
          list: true,
          formatter: (val) => this.formatNumber(val)
        }
      ],
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          type: 'donut',
        },
        legend: {
          show: true,
          position: 'bottom',
          floating: true
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: val => this.formatNumber(val) + ' tCO2'
          }
        },
        title: {
          text: '',
          align: 'center'
        },
        grid: {
          padding: {
            bottom: 30,
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: '14px',
                  formatter: val => this.formatNumber(val, 0)
                },
                total: {
                  show: true,
                  showAlways: true,
                  fontSize: '14px',
                  label: '총합',
                  color: 'black',
                  formatter: chart => this.formatNumber(chart.config.series.reduce((a, b) => a + b, 0), 0) + ' tCO2'
                }
              }
            }
          }
        },
      },
    }
  },
  methods: {
    async fetchData() {
      try {
        if (!this.productFamily || !this.productFamily.code || !this.productFamily.name) return
        if (!this.category) return

        this.loading = true

        // Set title
        this.chartOptions.title.text = this.category.label;

        let chartMeta = [{
          years: [new Date().getFullYear()],
          productFamilies: [this.productFamily.code],
          categories: [this.category.value],
          groupKeys: ['product_code', 'product_name']
        }]

        let param = new FormData();
        param.append('path', 'esg/lca/ghg_emission/main')
        param.append('json', JSON.stringify(chartMeta))

        let response = await axios.post('esg/lca/run/python/chart-data', param, {
          headers: { Authorization: accessToken() }
        });

        // If HTTP request fails, show an error
        if (!response.data.data) {
          return
        }

        // Set the newly fetched data
        let chartData = JSON.parse(response.data.data)[0].data;

        // Sort chart data in the descending order of GHG emissions
        chartData.sort((a, b) => b.values - a.values);

        // Keep the top 3 products and aggregate others into etc.
        if (chartData.length > 3) {
          let etc = { product_name: '기타', values: chartData.slice(3).reduce((a, b) => a + b.values) };
          chartData = [...chartData.slice(0, 3), etc]
        }

        this.chartOptions.labels = chartData.map(row => row.product_name)
        this.series = chartData.map(row => row.values)
        this.chartOptions.title.text = this.category.label;
        this.tableItems = chartData
      } catch (error) {
        this.loading = false
        await this.showError(error);
      } finally {
        this.loading = false
        this.refreshChart()
      }
    },
  }
}
</script>

<style scoped>
>>> table.table.custom-table.table-sm > thead > tr > th,
>>> table.table.custom-table.table-sm > tbody > tr > td {
  padding-left: .5rem;
  padding-right: .5rem;
}
</style>